import {CSSProperties, FC} from 'react';


export interface IIconStarNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconStarNissan: FC<IIconStarNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M19.238 10.136a.77.77 0 0 0-.655-.536l-4.335-.664L12.305 4.8a.76.76 0 0 0-.686-.451.76.76 0 0 0-.686.45L8.991 8.929 4.655 9.6a.773.773 0 0 0-.617.544.828.828 0 0 0 .19.8l3.147 3.2-.762 4.544a.82.82 0 0 0 .294.812.732.732 0 0 0 .826.052l3.886-2.136 3.886 2.136a.682.682 0 0 0 .35.096.737.737 0 0 0 .45-.152.82.82 0 0 0 .305-.8l-.762-4.544 3.146-3.2c.225-.2.32-.518.244-.816Zm-4.686 3.2a.825.825 0 0 0-.22.704l.548 3.36-2.865-1.6a.773.773 0 0 0-.716 0l-2.865 1.6.549-3.36a.825.825 0 0 0-.221-.704l-2.286-2.4 3.208-.488a.765.765 0 0 0 .579-.44l1.356-3.048 1.433 3.056a.765.765 0 0 0 .579.44l3.207.488-2.286 2.392Z" clipRule="evenodd" />
        </svg>
    );
};
